/* eslint-disable no-unused-expressions */
import { Routes, Route, useNavigate } from 'react-router-dom';
import {
  Login, Options, Layout, UploadPage, Review, ErrorPage, ChoosePage, Feedback, NotFound,
  Payment, OldLogin, ReturnMethod, Unfulfilled,
  SuccessPage,
} from '@pages';
import ChoosePackage from '@pages/dhgate/choose-package';
import ChooseItems from '@pages/dhgate/choose-items';
import DhgateOptions from '@pages/dhgate/options';
import DhgatePayment from '@pages/dhgate/payment';
import DhgateReview from '@pages/dhgate/review';
import DhgateUpload from '@pages/dhgate/upload';
import './App.css';
import { useDispatch } from 'react-redux';
import { useEffectOnce } from '@hooks';
import {
  ROUTE_ARR, PLATFORM_REG, dhgate, PLATFORM_NAME,
} from '@constants/claim';
import { setPlatform } from './store';

function App() {
  const { pathname, search } = window.location || {};

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 根据不同的platform 展示不同路径
  const oldUrlRedirect = () => {
    // console.log(PLATFORM_REG, pathname);
    let pathPlatform = (pathname?.match(PLATFORM_REG) || [])[0];// garmentory/treet/gently/poizon
    // dhgate 完全定制化开发，特殊处理
    if (pathname.indexOf(dhgate) > -1) {
      pathPlatform = dhgate;
    }
    if (pathname.indexOf(PLATFORM_NAME.SHOPPREMIUMOUTLETS) > -1) {
      const path = pathname.replace(PLATFORM_NAME.SHOPPREMIUMOUTLETS, PLATFORM_NAME.NEWSPO);
      navigate(path + search);
    }
    // 存储platform  重定向写在cloudFront function里面
    (pathPlatform) && dispatch(setPlatform(pathPlatform));
  };
  useEffectOnce(() => {
    oldUrlRedirect();
  }, []);
  return (
    <div className="App">
      <Routes>
        <Route path="*" element={<NotFound />} />
        {
          ROUTE_ARR.map((path) => (
            <Route path={path} key={path} element={<Layout />}>
              <Route index element={<Login />} />
              <Route path="options" element={<Options />} />
              <Route path="choose" element={<ChoosePage />} />
              <Route path="upload" element={<UploadPage />} />
              <Route path="review" element={<Review />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="payment" element={<Payment />} />
              <Route path="return_method" element={<ReturnMethod />} />
              <Route path="error" element={<ErrorPage />} />
              <Route path="return/*" element={<OldLogin />} />
              <Route path="unfulfilled" element={<Unfulfilled />} />
              <Route path="success" element={<SuccessPage />} />
            </Route>
          ))

        }
        <Route path={`/${dhgate}`} element={<Layout />}>
          <Route index element={<Login />} />
          <Route path="options" element={<DhgateOptions />} />
          <Route path="choose-package" element={<ChoosePackage />} />
          <Route path="choose-items" element={<ChooseItems />} />
          <Route path="upload" element={<DhgateUpload />} />
          <Route path="review" element={<DhgateReview />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="payment" element={<DhgatePayment />} />
          <Route path="return_method" element={<ReturnMethod />} />
          <Route path="error" element={<ErrorPage />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
